import { render, staticRenderFns } from "./StudentAwardSave.vue?vue&type=template&id=ac7636f2&"
import script from "./StudentAwardSave.vue?vue&type=script&lang=js&"
export * from "./StudentAwardSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports